const FinanceIcon = (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 3V21H21V3H3ZM5 5H19V19H5V5ZM11 7V9H7V7H11ZM11 11V13H7V11H11ZM17 7V13H13V7H17ZM17 15V17H7V15H17Z" />
  </svg>
);

export default FinanceIcon;
